var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"c-container tw-w-full tw-mx-auto tw-max-w-[calc(theme('maxWidth.6xl')+theme('padding.8')+theme('padding.8'))] data-[fluid='true']:tw-max-w-none",class:{
    'tw-px-4 xl:tw-px-8': !_vm.noPadding
  },attrs:{"data-fluid":_vm.fluid}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }